/* eslint-disable no-script-url */
import { Component, h, Listen, Prop, State } from '@stencil/core';
import { AppService, DomService, StringService } from '../../services';
import { remCalc } from '../../style';
import { TabEntry } from '../rcm-navigation/rcm-navigation.types';
import { VerticalAlign } from '../rcm-text-link/rcm-text-link.types';
import { Multilink, Target } from '../types/link.types';

@Component({
  tag: 'rcm-footer',
  styleUrl: 'rcm-footer.scss',
  shadow: true,
})
export class RcmFooter {
  @Prop({ mutable: true }) sitemapLinks: TabEntry[];

  @Prop({ attribute: 'sitemap-links' }) tempSitemapLinks: string;

  @Prop() countryCode: string;

  @Prop() isSalzburg = true;

  @State() highContrast = false;

  content: any;

  bottomLinks: any;

  currentUserType = AppService.getUserType();

  componentWillLoad() {
    this.content = DomService.getGlobalContent().footer;
    this.bottomLinks = this.buildBottomLinks();
    this.buildSitemapLinks();
  }

  @Listen('rcmUserSwitchClose', {
    target: 'window',
  })
  buildSitemapLinks() {
    const sitemapUnfiltered: Record<string, TabEntry[]> = this.tempSitemapLinks ? JSON.parse(this.tempSitemapLinks) : this.sitemapLinks;

    this.sitemapLinks = sitemapUnfiltered[this.currentUserType];
  }

  buildBottomLinks = (): {
    label: string;
    href: string;
  }[] =>
    this.content?.bottomLinks
      ? Object.keys(this.content.bottomLinks).map((key) => ({
          label: this.content.bottomLinks[key].label,
          href: this.content.bottomLinks[key].link,
        }))
      : [];

  renderSitemapLinks = () =>
    this.sitemapLinks?.map(
      (sitemapLink) =>
        Array.isArray(sitemapLink.children) && (
          <rcm-column span={4} class="sitemap__column" key={sitemapLink.href}>
            {sitemapLink.children.map((child) => (
              <rcm-text-link
                key={`${child.text}_${AppService.getUserType()}`}
                text={child.text}
                link={{ src: child.href, target: Target.SELF }}
                icon="chevron-right"
                color="var(--colors-grey-base)"
                verticalAlign={VerticalAlign.BASELINE}
              />
            ))}
          </rcm-column>
        ),
    );

  renderFooterBottomLinks = () =>
    this.bottomLinks?.map((entry, i) => {
      if (entry.label && entry.href) {
        const link: Multilink = { src: entry.href, target: StringService.isUrlOrFilename(entry.href) ? Target.BLANK : Target.SELF };
        return (
          <li key={entry.label + i}>
            <rcm-wrapper-link link={link} trackingLinkText={entry.label} parentComponent="rcm-footer">
              <span>{entry.label}</span>
            </rcm-wrapper-link>
          </li>
        );
      }
      return '';
    });

  render() {
    return (
      <footer class="footer">
        <div class="footer__container">
          <rcm-columns columnGap="0" class="footer__grid footer__main">
            <rcm-column span={12} spanXlarge={5}>
              <div class="footer__company-info">
                {this.isSalzburg ? (
                  <rcm-icon class="footer__logo" icon="rcm-logo-rsi2" height={`${remCalc(42)}rem`} ariaLabel={this.content?.logo.ariaLabel} />
                ) : (
                  <rcm-icon class="footer__logo" icon="rcm-logo2" width={`${remCalc(198)}rem`} ariaLabel={this.content?.logo.ariaLabel} />
                )}
                <p>{this.content?.infoText}</p>
              </div>
            </rcm-column>
            <rcm-column span={0} spanXlarge={7} class="footer__sitemap-links">
              <rcm-columns>{this.renderSitemapLinks()}</rcm-columns>
            </rcm-column>
          </rcm-columns>
          <rcm-high-contrast-toggle
            onRcmHighContrastToggle={() => {
              this.highContrast = !this.highContrast;
            }}
          />
          <hr />
          <rcm-columns class="footer__grid footer__bottom-links" multipleRows={true}>
            <rcm-column span={12} spanXlarge={12}>
              <ul>
                {this.renderFooterBottomLinks()}
                <li>
                  <button onClick={() => (window as any).OneTrust.ToggleInfoDisplay()}>{this.content?.cookieSettingsLabel}</button>
                </li>
              </ul>
            </rcm-column>
          </rcm-columns>
          <hr />
          <rcm-columns class="footer__grid footer__bottom-social" multipleRows={true}>
            <rcm-column span={12} spanXlarge={6}>
              <rcm-social-media-links highContrast={this.highContrast} />
            </rcm-column>
            <rcm-column span={12} spanXlarge={6}>
              <p>{this.content?.copyRightText}</p>
            </rcm-column>
          </rcm-columns>
        </div>
      </footer>
    );
  }
}
